// ######################################################
// index.js - Render the React App to the index.html file
// in olli-video-frontend/public/
// * YOU SHOULD NOT HAVE TO TOUCH THIS FILE.
// ######################################################


// These 2 depdencies make the app (barely) work on IE 11
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// Import depdendencies
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// Select the HTML doc element and render React app
ReactDOM.render(<App />, document.getElementById('root'));